import { useQuery } from "@tanstack/react-query";
import { OmsReportsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { OmsProduct, Stage } from "../lusca-search-api/generated-src";

export default function useOmsReport(product: OmsProduct) {
  return useQuery({
    queryKey: ["oms-report", product],
    staleTime: 60_000,
    retry: false,
    queryFn: async () =>
      (await OmsReportsApiFactory().getOmsReport(product, Stage.Prod)).data,
  });
}
